import type { SxProps, Theme } from '@mui/material/styles';
import {
  ultraWideDesktopQuery,
  wideDesktopQuery,
} from '../common/viewportBreakpoints';

export const dashboardWrappedGameTableSx: SxProps<Theme> = {
  tableLayout: 'fixed',
  width: '100%',
  '& .MuiTableCell-root': {
    fontSize: { xs: 14, sm: 15, md: 16 },
    lineHeight: 1.45,
    py: { xs: 0.75, sm: 0.9, md: 1 },
    px: 1,
    borderBottom: '1px solid',
    borderColor: 'divider',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    [`@media ${wideDesktopQuery}`]: {
      fontSize: 18,
      py: 1.25,
      px: 1.5,
    },
    [`@media ${ultraWideDesktopQuery}`]: {
      fontSize: 21,
      py: 1.6,
      px: 2,
    },
  },
  '& .MuiTableCell-head': {
    fontWeight: 600,
    bgcolor: 'action.hover',
    py: { xs: 0.6, sm: 0.75, md: 0.85 },
    [`@media ${wideDesktopQuery}`]: {
      py: 1.1,
    },
    [`@media ${ultraWideDesktopQuery}`]: {
      py: 1.35,
    },
  },
};
